import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signup, clearError } from "../../../redux/actions/userAction";

import { RiArrowGoBackFill } from "react-icons/ri";

import "./signup.css";

const Signup = () => {
	const userState = useSelector(state => state.user);
	const dispatch = useDispatch();
	const history = useHistory();

	const [errorMessage, setErrorMessage] = useState("");
	const [signupInfo, setSignupInfo] = useState({
		username: "",
		email: "",
		password: "",
		passwordCheck: "",
	});

	useEffect(() => {
		dispatch(clearError());
	}, []);

	useEffect(() => {
		console.log("Running", userState);
		if (userState.validToken) history.push("/");
		if (userState.err) {
			switch (userState.err) {
				case "Authorization denied, Invalid token":
				case "Authorization denied, No token":
					dispatch(clearError());
					break;
				case "Missing field":
					setErrorMessage(`Warning: ${userState.err}`);
					break;
				case "Email already exist":
				case "Username already exist":
				case "Password does't match":
					setErrorMessage(`Invalid input: ${userState.err}`);
					break;
			}
		}
	}, [userState]);

	return (
		<div className="signup-page">
			<input type="submit" className="logout-btn" value="BACK" onClick={() => history.push("/login")} />
			<div className="container">
				<form
					className="form-group input-spacing"
					onSubmit={e => {
						e.preventDefault();
						dispatch(signup(signupInfo));
					}}
				>
					<h1 className="title mb-5">Chess Live</h1>
					{userState.err === "" ? <div></div> : <div className="warning"> {errorMessage} </div>}

					<input
						type="text"
						name="username"
						placeholder="Username"
						required
						value={signupInfo.username}
						onChange={e => {
							setSignupInfo({ ...signupInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
						className="form-control form-control-sm mb-2 mt-2"
					/>

					<input
						type="email"
						name="email"
						placeholder="Email"
						required
						value={signupInfo.email}
						onChange={e => {
							setSignupInfo({ ...signupInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
						className="form-control form-control-sm mb-2"
					/>

					<input
						type="password"
						name="password"
						placeholder="Password"
						required
						value={signupInfo.password}
						onChange={e => {
							setSignupInfo({ ...signupInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
						className="form-control form-control-sm mb-2"
					/>
					<input
						type="password"
						name="passwordCheck"
						placeholder="Password Check"
						required
						value={signupInfo.passwordCheck}
						onChange={e => {
							setSignupInfo({ ...signupInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
						className="form-control form-control-sm mb-3"
					/>

					<input type="submit" value="Sign up" className="btn btn-primary mb-2 btn-fill" />
				</form>
			</div>
		</div>
	);
};

export default Signup;
